// import { PARAMS_SIGN_KEY, URL_PREFIX } from '../../../config';
var baseURL = '/';
var PARAMS_SIGN_KEY = ''; // if (process.env.NODE_ENV === 'production') {
//   baseURL = URL_PREFIX;
// }

export { PARAMS_SIGN_KEY, baseURL };